import { Component, h, page } from 'pylevate-runtime';
import { SharedChat } from '../ui/public.js';
export class Shared extends Component {
  render(props, state, context) {
    const children = props && props.children;
    return h('div', null, h(SharedChat, {token: this.props.token}));
  }
}
Shared = page({title: 'Shared chat — eutonomous', route: '/s/:token'})(Shared);
